/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"changelog_container"},[_c('CHANGELOG',{staticClass:"pl-5 pb-3"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }